import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email().toLowerCase().trim(),
    password: z.string().min(1, 'Password required'),
});
export const adminPublicSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=auth.js.map